import { render, staticRenderFns } from "./WorldMapHR.vue?vue&type=template&id=3ac33bb7&scoped=true"
import script from "./WorldMapHR.vue?vue&type=script&lang=js"
export * from "./WorldMapHR.vue?vue&type=script&lang=js"
import style0 from "./WorldMapHR.vue?vue&type=style&index=0&id=3ac33bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac33bb7",
  null
  
)

export default component.exports